import { useMemo } from 'react';
import { Link, useLoaderData } from 'react-router';
import { useIdeatMeta } from '../../common/hooks/useIdeatMeta.js';
import { allKeywordsDescriptionMsg, allKeywordsMsg, keywordsMsg, t } from '../../common/i18n';
import type { IdeatKeyword } from '../../generated/api/ideatKeyword.js';
import type { IdeatKeywordsResponse } from '../../generated/api/ideatKeywordsResponse.js';

import './IdeatKeywordsPage.scss';

const isLetter = (char: string) => /\p{L}/u.test(char);

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

const groupByFirstLetter = (keywords: IdeatKeyword[]) => {
  const groups: Record<string, IdeatKeyword[]> = {};
  for (const kw of keywords ?? []) {
    const first = kw.label[0];
    const key = first && isLetter(first) ? first.toUpperCase() : '#';
    if (groups[key] === undefined || groups[key] === null) {
      groups[key] = [];
    }
    groups[key]?.push(kw);
  }

  return Object.entries(groups)
    .sort(([a], [b]) => a.localeCompare(b, 'fi'))
    .map(([letter, items]) => ({
      letter,
      items: items.sort((a, b) => a.label.localeCompare(b.label, 'fi')),
    }));
};

export const IdeatKeywordsPath = () => {
  const { keywords } = useLoaderData() as IdeatKeywordsResponse;

  useIdeatMeta({
    title: t.ZZX2(allKeywordsMsg),
    description: t.ZZX3(allKeywordsDescriptionMsg),
  });

  const groups = useMemo(() => groupByFirstLetter(keywords), [keywords]);

  return (
    <div className="of-ideat-page">
      <div className="keywordsContainer">
        <h1>{t.ZZWV(keywordsMsg)}</h1>
        <div className="keywordGroups">
          {groups.map(({ letter, items }) => (
            <div key={letter}>
              <h3>{letter}</h3>
              <div className="keywordGroupBadges">
                {items.map(kw => (
                  <Link key={kw.href} to={kw.href} className="articleKeywordBadge">
                    {capitalize(kw.label)}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
